import Main from '@/layout/main.vue'
import Blank from '@/layout/blank.vue'

const routes = [
  {
    path: '/work_order',
    name: 'work_order',
    meta: { title: '工单' },
    redirect: '/work_order/list',
    component: Main,
    children: [
      // 工单管理
      {
        path: '/work_order',
        name: 'work_order_manage',
        meta: {
          title: '工单管理',
          parentPath: '/work_order',
          icon: 'icon_caiwu_yue'
        },
        redirect: '/work_order/list',
        component: Blank,
        children: [
          // 工单列表
          {
            path: '/work_order/list',
            name: 'work_order_list',
            meta: {
              title: '工单列表',
              parentPath: '/work_order',
              icon: 'icon_caiwu_yue',
              permission: ['work_order:view'],
              keepAlive: true
            },
            component: () => import('@/views/work_order/list.vue')
          },
          // 工单详情
          {
            path: '/work_order/detail',
            name: 'work_order_detail',
            meta: {
              hidden: true,
              title: '工单详情',
              parentPath: '/work_order',
              prevPath: '/work_order/list',
              permission: ['work_order:view']
            },
            component: () => import('@/views/work_order/detail.vue')
          },
          // 工单派单
          {
            path: '/work_order/dispatch',
            name: 'work_order_dispatch',
            meta: {
              hidden: true,
              title: '工单派单',
              parentPath: '/work_order',
              prevPath: '/work_order/list',
              permission: ['work_order:dispatch']
            },
            component: () => import('@/views/work_order/dispatch.vue')
          }
        ]
      },
      // 服务管理
      {
        path: '/work_order/service',
        name: 'work_order_service',
        meta: {
          title: '服务管理',
          parentPath: '/work_order',
          icon: 'icon_kdzs_fjrmb'
        },
        redirect: '/work_order/service/list',
        component: Blank,
        children: [
          // 服务列表
          {
            path: '/work_order/service/list',
            name: 'work_order_service_list',
            meta: {
              title: '服务列表',
              parentPath: '/work_order',
              icon: 'icon_fuwu_liebiao',
              permission: ['service:view'],
              keepAlive: true
            },
            component: () => import('@/views/work_order/service/list.vue')
          },
          // 添加服务
          {
            path: '/work_order/service/add',
            name: 'work_order_service_add',
            meta: {
              hidden: true,
              title: '添加服务',
              parentPath: '/work_order',
              prevPath: '/work_order/service',
              permission: ['service:add']
            },
            component: () => import('@/views/work_order/service/edit.vue')
          },
          // 编辑服务
          {
            path: '/work_order/service/edit',
            name: 'work_order_service_edit',
            meta: {
              hidden: true,
              title: '编辑服务',
              parentPath: '/work_order',
              prevPath: '/work_order/service',
              permission: ['service:edit']
            },
            component: () => import('@/views/work_order/service/edit.vue')
          },
          // 服务类型
          {
					    path: '/work_order/type',
					    name: 'work_order_type',
					    meta: {
					        title: '服务类型',
					        parentPath: '/work_order',
					        icon: 'icon_gongdan_leixing',
					        permission: ['work_order_type:manage'],
					        keepAlive: true
					    },
					    component: () => import('@/views/work_order/type/list.vue')
          },
          // 添加工单类型
          {
					    path: '/work_order/type/add',
					    name: 'work_order_type_add',
					    meta: {
					        hidden: true,
					        title: '添加服务类型',
					        parentPath: '/work_order',
					        prevPath: '/work_order',
					        permission: ['work_order_type:add']
					    },
					    component: () => import('@/views/work_order/type/edit.vue')
          },
          // 编辑工单类型
          {
					    path: '/work_order/type/edit',
					    name: 'work_order_type_edit',
					    meta: {
					        hidden: true,
					        title: '编辑服务类型',
					        parentPath: '/work_order',
					        prevPath: '/work_order',
					        permission: ['work_order_type:edit']
					    },
					    component: () => import('@/views/work_order/type/edit.vue')
          }
        ]
      },
      // 流程管理
      {
        path: '/work_order/process',
        name: 'work_order_process',
        meta: {
          title: '流程管理',
          parentPath: '/work_order',
          icon: 'icon_qudao',
          permission: ['process:view']
        },
        redirect: '/work_order/process/list',
        component: Blank,
        children: [
          // 流程定义列表
          {
            path: '/work_order/process/list',
            name: 'work_order_process_list',
            meta: {
              title: '流程定义',
              parentPath: '/work_order',
              icon: 'icon_liuchengdingyi',
              permission: ['process:view'],
              keepAlive: true
            },
            component: () => import('@/views/work_order/process/list.vue')
          },
          // 添加流程定义
          {
            path: '/work_order/process/add',
            name: 'work_order_process_add',
            meta: {
              hidden: true,
              title: '添加流程',
              parentPath: '/work_order',
              prevPath: '/work_order/process/list',
              permission: ['process:add']
            },
            component: () => import('@/views/work_order/process/edit.vue')
          },
          // 编辑流程定义
          {
            path: '/work_order/process/edit',
            name: 'work_order_process_edit',
            meta: {
              hidden: true,
              title: '编辑流程',
              parentPath: '/work_order',
              prevPath: '/work_order/process/list',
              permission: ['process:edit']
            },
            component: () => import('@/views/work_order/process/edit.vue')
          },
          // 流程节点设计
          {
            path: '/work_order/process/design',
            name: 'work_order_process_design',
            meta: {
              hidden: true,
              title: '流程设计',
              parentPath: '/work_order',
              prevPath: '/work_order/process/list',
              permission: ['process:design']
            },
            component: () => import('@/views/work_order/process/design.vue')
          },
          // 流程实例列表
          {
            path: '/work_order/process/instance',
            name: 'work_order_process_instance',
            meta: {
              hidden: true,
              title: '流程实例',
              parentPath: '/work_order',
              icon: 'icon_liuchengshili',
              permission: ['process_instance:view'],
              keepAlive: true
            },
            component: () => import('@/views/work_order/process/instance.vue')
          },
          // 审批记录
          {
            path: '/work_order/process/approval',
            name: 'work_order_process_approval',
            meta: {
              hidden: true,
              title: '审批记录',
              parentPath: '/work_order',
              icon: 'icon_shenpijilu',
              permission: ['process_approval:view'],
              keepAlive: true
            },
            component: () => import('@/views/work_order/process/approval.vue')
          }
        ]
      }
    ]
  }
]

export default routes
